import { GraphQLActivationTasksRequester } from '@cobliteam/api-lib';
import { useMutation, useQuery } from '@tanstack/react-query';

const getGraphQLOnboardingChecklistRequester = () => new GraphQLActivationTasksRequester();

const useActivationTasks = () => {
  const useGetUserActivationTasks = () =>
    useQuery({
      queryKey: ['userActivationTasks'],
      queryFn: () => getGraphQLOnboardingChecklistRequester().getUserActivationTasks(),
    });

  const useGetActivationTasks = (categories: string[]) =>
    useQuery({
      queryKey: ['activationTasks'],
      queryFn: () => getGraphQLOnboardingChecklistRequester().getActivationTasks(categories),
    });

  const useUpdateUserActivationTask = () =>
    useMutation({
      mutationFn: ({ id, finished }: { id: string; finished: boolean }) => getGraphQLOnboardingChecklistRequester().updateUserActivationTask(id, finished),
    });

  return {
    useGetActivationTasks,
    useGetUserActivationTasks,
    useUpdateUserActivationTask,
  };
};

export default useActivationTasks;
